// @flow
import React from 'react';
import { Route, Switch } from 'react-router';
import PageLoader from 'components/common/loader/PageLoader';

import PrivateRoute from 'components/common/router/PrivateRoute';
import AuthenticatedRoute from 'components/common/router/AuthenticatedRoute';

import StartScreen from 'components/pages/StartPage';
import Vehicle from 'components/pages/VehiclePage';
import Services from 'components/pages/ServicesPage';
import RecallPage from 'components/pages/RecallPage';
import RecallVinSearchPage from 'components/pages/RecallVinSearchPage';
import IndividualServices from 'components/pages/IndividualServicesPage';
import DeclinedServices from 'components/pages/DeclinedServicesPage';
import DropOffPage from 'components/pages/DropOffPage';
import AppointmentContainer from 'components/pages/AppointmentPage/AppointmentContainerPage';
import Review from 'components/pages/ReviewPage';
import Confirmation from 'components/pages/ConfirmationPage';
import CancellationPage from 'components/pages/Appointment/CancellationPage';
import TransportationPage from 'components/pages/TransportationPage';
import PickUpPage from 'components/pages/PickUpPage/PickUpPageWrapper';
import SignIn from 'components/pages/User/SignIn/';

// Utils
import {
  RECALL_SERVICES_ROUTE,
  RECALL_VIN_SEARCH_ROUTE
} from 'constants/routes';

const NoRoute = () => <div> Invalid route </div>;

// eslint-disable-next-line new-cap
const User = PageLoader({
  loader: () => import('../pages/User')
});

// eslint-disable-next-line react/no-multi-comp
const Router = () => {
  return (
    <Switch key="routes">
      <Route exact path="/" component={StartScreen} />
      <Route path="/signin" component={SignIn} />
      <PrivateRoute path="/vehicle" component={Vehicle} />
      <PrivateRoute path="/services" component={Services} />
      <PrivateRoute path={RECALL_SERVICES_ROUTE} component={RecallPage} />
      <PrivateRoute
        path={RECALL_VIN_SEARCH_ROUTE}
        component={RecallVinSearchPage}
      />
      <PrivateRoute path="/appointment" component={AppointmentContainer} />
      <PrivateRoute path="/review" component={Review} />
      <PrivateRoute path="/confirmation" component={Confirmation} />
      <PrivateRoute path="/cancellation" component={CancellationPage} />
      <PrivateRoute path="/individualservices" component={IndividualServices} />
      <PrivateRoute path="/declinedservices" component={DeclinedServices} />
      <PrivateRoute
        exact
        path="/transportation"
        component={TransportationPage}
      />
      <PrivateRoute path="/transportation/pickup" component={PickUpPage} />
      <PrivateRoute path="/transportation/dropOff" component={DropOffPage} />
      <AuthenticatedRoute path="/user" component={User} />
      <Route component={NoRoute} />
    </Switch>
  );
};

export default Router;



// WEBPACK FOOTER //
// ./src/components/consumer8/AppRouter.js